import React from 'react';
export function Datenschutz() {
  return <main className="max-w-[800px] mx-auto w-full px-6 py-10 flex-1" data-id="element-304">
      <h1 className="font-serif text-[2rem] font-bold text-brand-navy mb-8" data-id="element-305">
        Datenschutzerklärung
      </h1>

      <div className="font-body text-[1.1rem] leading-[1.8] text-brand-gray-600 space-y-6" data-id="element-306">
        <section data-id="element-307">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-308">
            1. Datenschutz auf einen Blick
          </h2>
          <h3 className="font-serif text-[1.2rem] font-semibold text-brand-navy mb-2 mt-4" data-id="element-309">
            Allgemeine Hinweise
          </h3>
          <p data-id="element-310">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
            besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können.
          </p>
        </section>

        <section data-id="element-311">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-312">
            2. Verantwortliche Stelle
          </h2>
          <p data-id="element-313">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser
            Website ist:
          </p>
          <p className="mt-2" data-id="element-314">
            Emerald Health Solutions Ltd.
            <br data-id="element-315" />
            Unit 12, Business Centre, Sandyford
            <br data-id="element-316" />
            Dublin 18, D18 X2P9, Ireland
            <br data-id="element-317" />
            Director: Liam O'Connor
            <br data-id="element-318" />
            Telefon: +353 1 496 0123
            <br data-id="element-319" />
            E-Mail: contact@emerald-health.ie
          </p>
        </section>

        <section data-id="element-320">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-321">
            3. Datenerfassung auf dieser Website
          </h2>
          <h3 className="font-serif text-[1.2rem] font-semibold text-brand-navy mb-2 mt-4" data-id="element-322">
            Cookies
          </h3>
          <p data-id="element-323">
            Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind
            kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an.
            Sie werden entweder vorübergehend für die Dauer einer Sitzung
            (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem
            Endgerät gespeichert.
          </p>

          <h3 className="font-serif text-[1.2rem] font-semibold text-brand-navy mb-2 mt-4" data-id="element-324">
            Server-Log-Dateien
          </h3>
          <p data-id="element-325">
            Der Provider der Seiten erhebt und speichert automatisch
            Informationen in so genannten Server-Log-Dateien, die Ihr Browser
            automatisch an uns übermittelt.
          </p>
        </section>

        <section data-id="element-326">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-327">
            4. Analyse-Tools und Werbung
          </h2>
          <p data-id="element-328">
            Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
            ausgewertet werden. Das geschieht vor allem mit sogenannten
            Analyseprogrammen. Detaillierte Informationen zu diesen
            Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.
          </p>
        </section>

        <section data-id="element-329">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-330">
            5. Ihre Rechte (DSGVO)
          </h2>
          <p data-id="element-331">
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
            jederzeit das Recht auf unentgeltliche Auskunft über Ihre
            gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger
            und den Zweck der Datenverarbeitung und ggf. ein Recht auf
            Berichtigung oder Löschung dieser Daten.
          </p>
        </section>

        <section data-id="element-332">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-333">
            6. SSL- bzw. TLS-Verschlüsselung
          </h2>
          <p data-id="element-334">
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
            Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
            oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-
            bzw. TLS-Verschlüsselung.
          </p>
        </section>

        <section data-id="element-335">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-336">
            7. Widerspruch gegen Werbe-Mails
          </h2>
          <p data-id="element-337">
            Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
            Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
            Werbung und Informationsmaterialien wird hiermit widersprochen.
          </p>
        </section>
      </div>
    </main>;
}